module.exports = __webpack_public_path__ + "static/media/sfl_10.1cf022be.jpg";